import React, { FC, HTMLProps } from 'react';
import classNames from 'classnames';
import styles from './excerpt_title.module.scss';
import { Hyperlink } from '../../Hyperlink';

type Props = {
  position?: number;
  visited?: boolean;
  id?: string;
} & HTMLProps<HTMLAnchorElement>;

export const ExcerptTitle: FC<Props> = ({
  visited,
  position,
  id,
  children,
  ...props
}) => {
  return (
    <Hyperlink
      {...props}
      data-test-id={id}
      id={id}
      className={classNames(styles.title, visited && styles.visited)}
    >
      {!!position && (
        <>
          {position}
          {`.\u00a0`}
        </>
      )}
      {children}
    </Hyperlink>
  );
};
